module.exports = __webpack_public_path__ + "img/Асептический некроз головки бедренной кости.bfb1c8a7.jpg";